import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://tmariegreene.com";
const DEFAULT_DESCRIPTION =
  "TMG Consulting Group helps employers, communities, and growing businesses develop their leaders, strengthen their workforce, and build systems that last.";

const SEO_BY_PATH = {
  "/": ["TMG Consulting Group · Leadership, workforce, and business systems consulting", DEFAULT_DESCRIPTION],
  "/about": ["Who We Are · TMG Consulting Group", "TMG Consulting Group is a Michigan-based consulting firm working where leadership, people, and operations meet."],
  "/offerings": ["Our Offerings · TMG Consulting Group", "Consulting, speaking, training, and AI — four ways we help organizations, leaders, and growing businesses build stronger people and systems that last."],
  "/funding-readiness-worksheet": ["Funding Readiness Worksheet · TMG Consulting Group", "A free 23-question worksheet that scores your funding readiness and delivers a personalized PDF roadmap."],
  "/ai-readiness": ["AI Readiness Checklist · TMG Consulting Group", "A free 16-question checklist that scores your AI readiness and delivers a personalized PDF report."],
  "/book-call": ["Book a Discovery Call · TMG Consulting Group", "A 30-minute discovery call to understand your goals and tell you honestly whether we're the right fit."],
  "/contact": ["Contact · TMG Consulting Group", "Get in touch with TMG Consulting Group in Ypsilanti, Michigan."],
};

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const [title, description] = SEO_BY_PATH[pathname] || [
      "TMG Consulting Group",
      DEFAULT_DESCRIPTION,
    ];
    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
    setMeta("name", "description", description);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:description", description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE_URL}${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);

  return null;
}
